import { makeAutoObservable } from 'mobx';
import { validateRatchetBracket } from './validateRatchetBracket';

export class RatchetBracketData {
  mode = 'EQUAL_INTERVAL';
  targetPerBracket = 1;
  stopPerBracket = 1;
  qtyBasisValuePerBracket = 0;
  qtyBasis = 'PERCENT';
  trailQtyBasisValue = 0;
  trailAmount = 0;
  /** Unit for target/stop amounts. Only relevant for futures symbols. */
  valueUnit = 'DOLLARS';
  // OCO_ANCHORED mode fields — null when mode is EQUAL_INTERVAL
  ocoStopPrice = null;
  ocoTargetPrice = null;
  ocoNumberOfTargets = null;

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach((field) => {
        if (
          field === 'trailQtyBasisValue' &&
          (initialData.qtyBasis === 'PERCENT' ||
            initialData.qtyBasis === 'PROFIT')
        ) {
          this.trailQtyBasisValue =
            Number(initialData.trailQtyBasisValue) * 100;
        } else if (
          field === 'qtyBasisValuePerBracket' &&
          initialData.qtyBasis === 'PERCENT'
        ) {
          this.qtyBasisValuePerBracket =
            initialData.qtyBasisValuePerBracket * 100;
        } else {
          this[field] = initialData[field];
        }
      });
    }
  }

  resetToDefaults = () => {
    this.mode = 'EQUAL_INTERVAL';
    this.targetPerBracket = 1;
    this.stopPerBracket = 1;
    this.qtyBasisValuePerBracket = 0;
    this.qtyBasis = 'PERCENT';
    this.trailQtyBasisValue = 0;
    this.trailAmount = 0;
    this.valueUnit = 'DOLLARS';
    this.ocoStopPrice = null;
    this.ocoTargetPrice = null;
    this.ocoNumberOfTargets = null;
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = () => {
    const result = validateRatchetBracket(this);
    return result;
  };
  returnJson = () => {
    const base = {
      mode: this.mode,
      qtyBasisValuePerBracket:
        this.qtyBasis === 'PROFIT' || this.qtyBasis === 'PERCENT'
          ? Number(this.qtyBasisValuePerBracket) / 100
          : this.qtyBasisValuePerBracket,
      qtyBasis: this.qtyBasis,
      trailQtyBasisValue:
        this.qtyBasis === 'PROFIT' || this.qtyBasis === 'PERCENT'
          ? Number(this.trailQtyBasisValue) / 100
          : this.trailQtyBasisValue,
      trailAmount: this.trailAmount,
      valueUnit: this.valueUnit,
    };
    if (this.mode === 'OCO_ANCHORED') {
      return {
        ...base,
        ocoStopPrice: this.ocoStopPrice,
        ocoTargetPrice: this.ocoTargetPrice,
        ocoNumberOfTargets: this.ocoNumberOfTargets,
      };
    }
    return {
      ...base,
      targetPerBracket: this.targetPerBracket,
      stopPerBracket: this.stopPerBracket,
    };
  };

  setMode = (string) => {
    this.mode = string;
  };
  setTargetPerBracket = (number) => {
    this.targetPerBracket = number;
  };
  setStopPerBracket = (number) => {
    this.stopPerBracket = number;
  };
  setQtyBasisValuePerBracket = (number) => {
    this.qtyBasisValuePerBracket = number;
  };
  setQtyBasis = (string) => {
    this.qtyBasis = string;
  };
  setTrailQtyBasisValue = (number) => {
    this.trailQtyBasisValue = number;
  };
  setTrailAmount = (number) => {
    this.trailAmount = number;
  };
  setValueUnit = (unit) => {
    this.valueUnit = unit;
  };
  setOcoStopPrice = (number) => {
    this.ocoStopPrice = number;
  };
  setOcoTargetPrice = (number) => {
    this.ocoTargetPrice = number;
  };
  setOcoNumberOfTargets = (number) => {
    this.ocoNumberOfTargets = number;
  };
}
